import { createRoot } from "react-dom/client";
import App from "./App";
import { AdminScreen } from "./components/AdminScreen";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root introuvable dans index.html");

const isAdmin = window.location.pathname.replace(/\/+$/, "") === "/admin";

createRoot(root).render(isAdmin ? <AdminScreen /> : <App />);
